export default "__VITE_ASSET__cnwtTyRu__"